module.exports = __webpack_public_path__ + "static/tusas3-47ebd200990418100df205f48a9e2480.png";